const API_BASE = String(import.meta.env.VITE_API_BASE || "").replace(/\/$/, "");
const TOKEN_KEY = "safetyvision_magic_token";
const USER_KEY = "safetyvision_magic_user";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch {
    return null;
  }
}

export function setSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
  window.dispatchEvent(new CustomEvent("magic-session-change"));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.dispatchEvent(new CustomEvent("magic-session-change"));
}

export class ApiError extends Error {
  constructor(message, status, payload) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.payload = payload;
  }
}

export async function request(path, options = {}) {
  const headers = new Headers(options.headers || {});
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (options.body && !(options.body instanceof FormData)) {
    headers.set("Content-Type", "application/json");
  }

  let response;
  try {
    response = await fetch(`${API_BASE}${path}`, { ...options, headers });
  } catch (error) {
    throw new ApiError("无法连接本地服务，请先启动后端。", 0, error);
  }

  const payload = await response.json().catch(() => ({}));
  if (response.status === 401) clearSession();
  if (!response.ok) {
    throw new ApiError(payload?.message || `请求失败（${response.status}）`, response.status, payload);
  }
  return payload;
}

export const api = {
  login: (account, password) => request("/uniappAPI/User/UserAccountLogin", {
    method: "POST",
    body: JSON.stringify({ account, password }),
  }),
  exams: () => request("/uniappAPI/Exam/getExamSubjects"),
  hotExams: () => request("/uniappAPI/IndexHotExam/getHotExamList"),
  examTypes: (examId) => request(`/uniappAPI/Exam/getExamSubjectTypes/${encodeURIComponent(examId)}`),
  membership: () => request("/uniappAPI/membership/entitlements"),
  quota: () => request("/uniappAPI/membership/quota"),
  documents: () => request("/uniappAPI/protected-library/documents/list", {
    method: "POST",
    body: JSON.stringify({}),
  }),
  documentDetail: (documentId) => request("/uniappAPI/protected-library/documents/detail", {
    method: "POST",
    body: JSON.stringify({ documentId }),
  }),
  pageToken: (documentId, pageNumber, detailIndex) => request("/uniappAPI/protected-library/pages/token", {
    method: "POST",
    body: JSON.stringify({
      documentId,
      pageNumber,
      ...(Number.isInteger(detailIndex) ? { detailIndex } : {}),
    }),
  }),
  downloadToken: (documentId) => request("/uniappAPI/membership/materials/download-token", {
    method: "POST",
    body: JSON.stringify({ documentId }),
  }),
  redeem: (code) => request("/uniappAPI/protected-library/redeem", {
    method: "POST",
    body: JSON.stringify({ code }),
  }),
};
